
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/Articles",
      function () {
        return require("private-next-pages/components/Articles/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/Articles"])
      });
    }
  